module.exports = __webpack_public_path__ + "static/media/3.28cfb854.png";